import { Component, Input, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { PaginationService } from 'src/app/PaginationService';
import { AppService } from 'src/app/app.service';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { messageService } from 'src/app/message.service';
import { qmsService } from 'src/app/qms/qms.service';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { any } from 'underscore';

@Component({
  selector: 'app-document-tags',
  templateUrl: './document-tags.component.html',
  styleUrls: ['./document-tags.component.scss']
})
export class DocumentTagsComponent implements OnInit {

  @Input() documentData: any = {};
  @Input() type: any;
  isProcessing = false;
  documentTagsList: any = [];
  documentTagData: any = {};
  searchValue: string = '';
  operationFlag: any;
  title = "";

  showingRowsText = "Showing rows";
  perPage = 10;
  maxSize = 3;
  collectionSize: number;

  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;

  moduleSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  visibleAddOrEditTagPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeleteTagPopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchTaskPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('addOrEditTagPopup', { static: true }) addOrEditTagPopup: TemplateRef<any>;
  @ViewChild('deleteTagPopup', { static: true }) deleteTagPopup: TemplateRef<any>;
  @ViewChild('searchTaskPopup', { static: true }) searchTaskPopup: TemplateRef<any>;

  moduleDropdown: any = [];


  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  addOrEditTagPopupConfig = {
    width: '700px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  deleteTagPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };



  searchTagPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };



  constructor(public appService: AppService, private snackBar: MatSnackBar, public paginationService: PaginationService, public dialog: MatDialog,
    public message: messageService, public router: Router, public qmsservice: qmsService) {

  }

  tagsList: any = [];
  selectedModule: any = null;
  selectedModuleValue: any = null;
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  ngOnInit(): void {
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.isProcessing = true;
    this.appService.getDistinctTags().subscribe((data: any) => {
      this.isProcessing = false;
      this.tagsList = data;
      this.selectBoxForTags();
    })
  }

  selectBoxForTags() {
    this.moduleDropdown = [];
    for (let i = 0; i < this.tagsList.length; i++) {
      this.moduleDropdown = this.moduleDropdown.concat({
        valueExp: this.tagsList[i],
        displayExp: this.tagsList[i]
      });
    }
  }

  onModuleValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedModuleValue = item.valueExp;
        this.documentTagData.taskId = null;
        this.documentTagData.taskNo = null;
      } else {
        this.selectedModuleValue = null;
        this.documentTagData.taskId = null;
        this.documentTagData.taskNo = null;
      }
    }
  }

  onModuleValueSelectOld(item: any) {
    this.selectedModuleValue = item.valueExp;
    this.documentTagData.taskId = null;
    this.documentTagData.taskNo = null;
  }

  onModuleValueRemoved(item: any) {
    this.selectedModuleValue = null;
    this.documentTagData.taskId = null;
    this.documentTagData.taskNo = null;
  }

  refreshGrid() {
    this.ngOnChanges();
  }

  columnList: any;
  ngOnChanges(): void {
    if (this.type == "Tagging") {
      this.columnList = [{ column: "Module", width: "120px" }, { column: "Task Id", width: "200px" }, { column: "Version", width: "100px" }, { column: "Status", width: "140px" },
      { column: "Task Details", width: "200px" }, { column: "Comments", width: "200px" },
      { column: "Created On", width: "140px" }, { column: "Created By", width: "140px" },
      { column: "Updated On", width: "140px" }, { column: "Updated By", width: "140px" }]
      this.isProcessing = true;
      this.appService.getDocumentTagsList(this.documentData['documentId'],
        this.documentData['version']).subscribe((data: any) => {
          this.isProcessing = false;
          this.documentTagsList = data;
          this.collectionSize = this.documentTagsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        })
    } else {
      this.columnList = [{ column: "Document No.", width: "200px" }, { column: "Status", width: "140px" }
        , { column: "Comments", width: "200px" },
      { column: "Created On", width: "140px" }, { column: "Created By", width: "140px" },
      { column: "Updated On", width: "140px" }, { column: "Updated By", width: "140px" }]
      this.isProcessing = true;
      this.appService.getDocumentTagged(this.documentData['documentId']).subscribe((data: any) => {
        this.isProcessing = false;
        this.documentTagsList = data;
        this.collectionSize = this.documentTagsList.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      })
    }

  }

  pager: any = {};
  pagedItems: any[];
  makeStickyColumns: any;

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;

  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.documentTagsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.documentTagsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      this.childCheckBoxs = true;
      for (let p = 0; p < this.documentTagsList.length; p++) {
        this.documentTagsList[p].childCheckBoxs = true;
      }

    } else {
      this.childCheckBoxs = false;
      for (let p = 0; p < this.documentTagsList.length; p++) {
        this.documentTagsList[p].childCheckBoxs = false;
      }
    }
  }
  deleteReason: any = "";
  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    //console.log(e);
    //console.log(list);
    //console.log(idx);
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }



  addTagFunc(event: any) {
    this.documentTagData = {};
    this.documentTagData['documentId'] = this.documentData['documentId'];
    this.documentTagData['documentVersion'] = this.documentData['version'];
    this.documentTagData['taskNo'] = null;
    this.documentTagData['module'] = null;
    this.documentTagData['taskversion'] = null;
    this.documentTagData['comments'] = null;
    this.selectedModule = null;
    this.selectedModuleValue = null;
    this.documentTagData['taskId'] = null;
    this.operationFlag = "ADD";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.title = "Add Tag";
    this.visibleAddOrEditTagPopup = this.dialog.open(this.addOrEditTagPopup, this.addOrEditTagPopupConfig);
  }

  editTagFunc(tagData: any, event: any) {
    this.documentTagData = tagData;
    this.isProcessing = true;
    this.appService.getDocumentTagByTagId(tagData['documentId'],
      tagData['documentVersion'], tagData['tagId']).subscribe((data: any) => {
        this.isProcessing = false;
        this.documentTagData = data[0];

        if (this.documentTagData.module != null) {
          this.selectedModuleValue = this.documentTagData.module;
          for (let i = 0; i < this.moduleDropdown.length; i++) {
            if (this.moduleDropdown[i].valueExp == this.documentTagData.module) {
              this.selectedModule = this.moduleDropdown[i].valueExp;
              /*  this.selectedModule = [{
                 valueExp: this.moduleDropdown[i].valueExp,
                 displayExp: this.moduleDropdown[i].displayExp
               }] */
            }
          }
        }
      })
    this.operationFlag = "EDIT";
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.title = "Update Tag";
    this.visibleAddOrEditTagPopup = this.dialog.open(this.addOrEditTagPopup, this.addOrEditTagPopupConfig);
  }

  cancelAddAndEditFunction() {
    this.visibleAddOrEditTagPopup.close();
  }

  module: any;
  taskNo: any;
  moduleRequiredMsg: any;
  taskNoRequiredMsg: any;
  fieldValidation() {
    this.module = document.getElementById('module') as HTMLInputElement;
    this.taskNo = document.getElementById('taskId') as HTMLInputElement;
    this.moduleRequiredMsg = document.getElementById('module-required-msg') as HTMLInputElement;
    this.taskNoRequiredMsg = document.getElementById('taskId-required-msg') as HTMLInputElement;

    if (this.selectedModuleValue == null || this.selectedModuleValue == "") {
      this.module.style.border = '1px solid red';
      this.moduleRequiredMsg.style.display = 'block';
    } else {
      this.module.style.border = 'none';
      this.moduleRequiredMsg.style.display = 'none';
    }

    if (this.documentTagData.taskNo == null || this.documentTagData.taskNo == "") {
      this.taskNo.style.border = '1px solid red';
      this.taskNoRequiredMsg.style.display = 'block';
    } else {
      this.taskNo.style.border = 'none';
      this.taskNoRequiredMsg.style.display = 'none';
    }


  }

  addOrUpdateTag(tagData: any) {
    if (this.selectedModuleValue == null || this.selectedModuleValue == "" || this.documentTagData.taskNo == null ||
      this.documentTagData.taskNo == "") {
      this.fieldValidation();
    } else {
      this.isProcessing = true;
      if (this.documentTagData['tagId'] == null || this.documentTagData['tagId'] == undefined) {

        this.documentTagData['module'] = this.selectedModuleValue;
        this.appService.createDocumentTag(this.documentTagData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditTagPopup.close();
            this.isProcessing = true;
            this.appService.getDocumentTagsList(this.documentData['documentId'],
              this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.documentTagsList = data;
                this.collectionSize = this.documentTagsList.length;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {

        this.documentTagData['module'] = this.selectedModuleValue;
        delete this.documentTagData['createdOn'];
        delete this.documentTagData['updatedOn'];
        this.appService.updateDocumentTag(this.documentTagData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleAddOrEditTagPopup.close();
            this.isProcessing = true;
            this.appService.getDocumentTagsList(this.documentData['documentId'],
              this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.documentTagsList = data;
                this.collectionSize = this.documentTagsList.length;
                this.pager.totalPages = undefined;
                this.setPage(1, 0);
              })
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }
    }



  }


  openDeletePopup(tagData: any, event: any) {
    this.documentTagData = tagData;
    this.title = "Delete Tag";
    this.deleteReason = "";
    this.visibleDeleteTagPopup = this.dialog.open(this.deleteTagPopup, this.deleteTagPopupConfig);
  }

  cancelDeleteFunction() {
    this.visibleDeleteTagPopup.close();
  }

  deleteValidation() {
    const deleteReasonValue = document.getElementById('deleteReason') as HTMLInputElement;
    const deleteReasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;
    if (this.deleteReason == "") {
      deleteReasonValue.style.border = '1px solid red';
      deleteReasonRequiredMsg.style.display = 'block';
    } else {
      deleteReasonValue.style.border = 'none';
      deleteReasonRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction() {
    if (this.deleteReason == "") {
      this.deleteValidation();
    } else {
      this.isProcessing = true;
      delete this.documentTagData['createdOn'];
      delete this.documentTagData['updatedOn'];
      this.documentTagData.deleteReason = this.deleteReason;
      this.appService.deleteDocumentTag(this.documentTagData).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
        }
        this.visibleDeleteTagPopup.close();
        this.isProcessing = true;
        this.appService.getDocumentTagsList(this.documentData['documentId'],
          this.documentData['version']).subscribe((data: any) => {
            this.isProcessing = false;
            this.documentTagsList = data;
            this.collectionSize = this.documentTagsList.length;
            this.pager.totalPages = undefined;
            this.setPage(1, 0);
          })
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }
  }

  searchByTaskId: any = "";

  searchTaskFunction() {
    this.searchByTaskId = "";
    this.documentTagData['taskId'] = null;
    this.documentTagData['taskNo'] = null;
    this.isShowSearchedTaskGrid = false;
    this.getSelectedTaskNo = null;
    this.getSelectedTaskversion = null;
    this.getSelectedTaskId = null;
    this.visibleSearchTaskPopup = this.dialog.open(this.searchTaskPopup, this.searchTagPopupConfig);
  }


  gridResetFunction() {
    this.searchByTaskId = "";
    this.searchedTaskList = [];
    this.isShowSearchedTaskGrid = false;
  }

  isShowSearchedTaskGrid = false;
  searchedTaskList: any = [];
  seachTaskForDocumentsFunc() {
    this.isShowSearchedTaskGrid = true;
    this.isProcessing = true;

    if (this.searchByTaskId == "") {
      this.searchByTaskId = undefined;
    }

    this.appService.searchTasksByTaskId(

      this.selectedModuleValue,
      this.searchByTaskId
    ).subscribe(
      (data: any) => {
        if (Array.isArray(data)) {
          const latestTasksMap = new Map<string, any>();

          data.forEach((task: any) => {
            const existingTask = latestTasksMap.get(task.taskId);

            if (!existingTask || task.version > existingTask.version) {
              latestTasksMap.set(task.taskId, task);
            }
          });

          this.searchedTaskList = Array.from(latestTasksMap.values());
        } else {
          this.searchedTaskList = data || [];
        }

        this.isProcessing = false;
      },
      (error: any) => {
        console.error("Error fetching tasks:", error);
        this.isProcessing = false;
      }
    );
  }

  getSelectedTaskNo: any = null
  getSelectedTaskversion: any = null
  getSelectedTaskId: any = null;
  previousTaskSelectedIndex: number = -1;
  searchTaskChildCheckBoxChecked(e: any, task: any, index: number) {
    if (e.target.checked) {
      if (this.previousTaskSelectedIndex !== -1 && this.searchedTaskList[this.previousTaskSelectedIndex]) {
        this.searchedTaskList[this.previousTaskSelectedIndex].searchTaskChildCheckBoxs = false;
      }

      task.searchTaskChildCheckBoxs = true;
      this.previousTaskSelectedIndex = index;
      this.getSelectedTaskNo = task.taskNo;
      this.getSelectedTaskversion = task.version;
      this.getSelectedTaskId = task.taskId;
    } else {
      task.searchTaskChildCheckBoxs = false;
      this.getSelectedTaskNo = null;
      this.getSelectedTaskversion = null;
      this.getSelectedTaskId = null;
      this.previousTaskSelectedIndex = -1;
    }
  }


  addTaskFunction() {
    this.documentTagData.taskNo = this.getSelectedTaskNo;
    this.documentTagData.taskVersion = this.getSelectedTaskversion;
    this.documentTagData.taskId = this.getSelectedTaskId;
    this.visibleSearchTaskPopup.close();
  }

  cancelTaskFunction() {
    this.visibleSearchTaskPopup.close();
  }

  ownerListDropdown: any = [];
  selectBoxForOwner() {
    this.ownerListDropdown = [];
    for (let j = 0; j < this.dropDownForOwner.length; j++) {
      this.ownerListDropdown = this.ownerListDropdown.concat({
        valueExp: this.dropDownForOwner[j].userId,
        displayExp: this.dropDownForOwner[j].userName
      });
    }
  }

  dropDownForOwner: any = [];
  selectedGroupValue: any = [];
  trainingData: any;
  dropDownForCategories: any = [];
  goToDetailPage(data: any, event: any) {
    event.preventDefault();
    this.isProcessing = true;
    this.message.taskLevelData = {};
    this.qmsservice.cancelButtonFrom = "Document";
    this.qmsservice.taskModuleName = data.module;
    this.qmsservice.moduleName = data.module;
    if (data.module == 'CR') {
      this.appService.getCrByCrNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        //this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.module;
        this.message.showLeftMenu = 'Main';
        this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
          this.qmsservice.userRole = response1;
          this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
          this.qmsservice.groupNameAndValue = this.selectedGroupValue;
          if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
            this.qmsservice.loggedInitiaor = true;
          } else {
            this.qmsservice.loggedInitiaor = false;
          }
          this.isProcessing = false;

          this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
            this.dropDownForOwner = data1;
            this.selectBoxForOwner();

            this.qmsservice.activityId = data.taskId;
            this.message.activityId = data.taskId;
            this.qmsservice.moduleName = data.module;
            this.isProcessing = false;
            this.message.breadcrumbData.thirdLevel = this.message.breadcrumbData.thirdLevel//+" ("+list.CR_ID+")";
            //this.message.breadcrumbData.secondLevel="Change Request" +" > "+ this.selectedGroupValue[0].displayExp;
            this.message.breadcrumbData.fourthLevel = data.taskId;
            this.router.navigate(['dashboard/qmsCr']);
          });
        });
      });
    } else if (data.moduleCode == 'DV') {
      this.appService.getDvByDvNo(data.taskNo).subscribe((response: any) => {
        this.qmsservice.activity = response;
        this.isProcessing = false;
        this.qmsservice.selectedActivityGroupId = response.groupId;
        this.qmsservice.selectedGroup = response.groupId;
        this.qmsservice.moduleName = data.moduleCode;
        this.message.showLeftMenu = 'Main';

        this.appService.getQmsGroupDetailsByModule(response.groupId, this.qmsservice.moduleName).subscribe((data1: any) => {
          this.qmsservice.selectedGroupDetailData = data1;

          this.appService.getQmsActiveUserByGroupIdModuleUserId(response.groupId, this.qmsservice.moduleName).subscribe((response1: any) => {
            this.qmsservice.userRole = response1;
            this.selectedGroupValue = [{
              valueExp: this.qmsservice.userRole[0].groupId,
              displayExp: this.qmsservice.userRole[0].groupName
            }];
            this.qmsservice.SelectedGroupNameAndValue = this.selectedGroupValue;
            this.qmsservice.groupNameAndValue = this.selectedGroupValue;
            this.isProcessing = false;

            if (this.qmsservice.userRole[0]?.qmsRoles.includes("Initiator")) {
              this.qmsservice.loggedInitiaor = true;
            } else {
              this.qmsservice.loggedInitiaor = false;
            }

            this.appService.getQmsActiveGroupUsers(this.qmsservice.selectedGroup, this.qmsservice.moduleName, 'Effectiveness Check Performer').subscribe((data1: any) => {
              this.dropDownForOwner = data1;
              this.selectBoxForOwner();

              if (data.subModuleName != null) {
                if (data.subTaskName.includes("-")) {
                  let temp1 = data.subTaskName.split("-");
                  temp1 = temp1[1].replace(/\s/g, "");
                };
              }

              if (data.subTaskName != null) {
                if (data.subTaskName.includes("-")) {
                  let checkReqForValue = data.subTaskName.split("- ");
                  console.log(checkReqForValue[1]);
                };
              }

              this.qmsservice.activityId = data.taskNo;
              this.message.activityId = data.taskNo;
              this.qmsservice.moduleName = data.moduleCode;

            });

          });

        });

      });
    } else if (data.module == "TRN") {
      this.isProcessing = true;
      this.appService.getTrainingByTrainingIdFirstTime(data.taskNo
      ).subscribe((data: any) => {
        this.isProcessing = false;
        this.trainingData = data[0];
        this.trainingData['isFromDashboard'] = true;
        this.appService.getCategoriesList().subscribe((data: any) => {
          this.dropDownForCategories = data;
          this.appService.setTrainingDetails(this.dropDownForCategories, this.trainingData);
          this.message.breadcrumbData.firstLevel = "Document";
          this.message.breadcrumbData.secondLevel = "Repository";
          this.message.breadcrumbData.thirdLevel = this.trainingData.trainingName + "(" + this.trainingData.trainingCode + ")";
          this.router.navigate(['/dashboard/addTraining']);
        })
      })
    }
  }


  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(viewType: any, tag: any) {
    if (viewType == 'overAll') {
      this.message.tableOrView_Name = "DMS_DOCUMENT_TAGS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,DOCUMENT_NO,DOCUMENT_VERSION,MODULE,TASK_DETAILS,TASK_ID,TASK_VERSION,COMMENTS,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Ts,End Ts,Action Flag,Document No,Document Version,Module,Task Details,Task Id,Task Version,Comments,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
      this.message.whereClause_AU = " AND DOCUMENT_ID=" + this.documentData['documentId'];
      this.message.columnList_Report = "Created Ts,End Ts,Action Flag,Document No,Document Version,Module,Task Details,Task Id,Task Version,Comments,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
      this.message.whereClause_Report = " WHERE DOCUMENT_ID=" + this.documentData['documentId'];
      this.message.report_And_Popup_Name = 'Document Tags Audit Trail [' + this.documentData['documentName'] + ']';
      this.staticAuditTrailComponent.triggerTrail(tag);
    } else {
      this.message.tableOrView_Name = "DMS_DOCUMENT_TAGS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,DOCUMENT_NO,DOCUMENT_VERSION,MODULE,TASK_DETAILS,TASK_ID,TASK_VERSION,COMMENTS,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON,DELETED_BY_USER,DELETED_REASON";
      this.message.columnList_UI = "Created Ts,End Ts,Action Flag,Document No,Document Version,Module,Task Details,Task Id,Task Version,Comments,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
      this.message.whereClause_AU = " AND DOCUMENT_ID=" + this.documentData['documentId'] + " AND TAG_ID=" + tag['tagId'];
      this.message.columnList_Report = "Created Ts,End Ts,Action Flag,Document No,Document Version,Module,Task Details,Task Id,Task Version,Comments,Created By,Created On,Updated By,Updated On,Deleted By,Deleted Reason";
      this.message.whereClause_Report = " WHERE DOCUMENT_ID=" + this.documentData['documentId'] + " AND TAG_ID=" + tag['tagId'];
      this.message.report_And_Popup_Name = 'Document Tags Audit Trail [' + this.documentData['documentName'] + ']';
      this.staticAuditTrailComponent.triggerTrail(tag);
    }
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "DMS_DOCUMENT_TAGS_VW";
    this.excelPdf.columnList_DB = "DOCUMENT_NO,DOCUMENT_VERSION,MODULE,TASK_DETAILS,TASK_ID,TASK_VERSION,COMMENTS,CREATED_BY_USER,CREATED_ON,UPDATED_BY_USER,UPDATED_ON";
    this.excelPdf.columnList_Report = "Document No,Document Version,Module,Task Details,Task Id,Task Version,Comments,Created By,Created On,Updated By,Updated On";
    this.excelPdf.whereClause_Report = " WHERE DOCUMENT_ID=" + this.documentData['documentId'];
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Document Tags Report [' + this.documentData['documentName'] + ']';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

}
